// Per-client editorial pitch + product/sector badges.
// The pitch replaces the generic "kind of business the industry runs on" copy.
// Badges are (icon name from lucide-react, label) pairs.

export const CLIENT_PITCHES = {
  aco: {
    pitch:
      "The name UK highways engineers reach for when a project needs proven surface-water and drainage systems. Their kit sits under motorway junctions, city streets and airports across the country.",
    badges: [
      ["Droplets", "Drainage Systems"],
      ["Waves", "Water Management"],
    ],
  },
  blakedale: {
    pitch:
      "One of the most recognisable names in the UK traffic-management vehicle scene. When operations need serious kit, IPVs, TMAs, marker vehicles, Blakedale is usually in the frame.",
    badges: [
      ["Truck", "TM Vehicles"],
      ["Shield", "IPVs & TMAs"],
    ],
  },
  "blinc-light": {
    pitch:
      "Turning safety visibility into a real product category. Blinc's illuminated Chapter 8 kit is quietly re-writing how the industry thinks about roadside conspicuity.",
    badges: [
      ["Lightbulb", "Illuminated Signage"],
      ["Shield", "Chapter 8"],
    ],
  },
  "bt-hs": {
    pitch:
      "A traffic-management and civils contractor with real depth, the type of team that runs projects other people talk about. Strong on people, community, and the kit to back it up.",
    badges: [
      ["Construction", "Traffic Management"],
      ["HardHat", "Civils"],
    ],
  },
  cappagh: {
    pitch:
      "London civils that just get on with it, utility, drainage, highways and waste programmes delivered at a pace few competitors match.",
    badges: [
      ["HardHat", "Civil Engineering"],
      ["Wrench", "Utilities"],
    ],
  },
  "cd-fencing": {
    pitch:
      "The go-to fencing outfit for sites that can't afford to look temporary. Serious perimeter work, done properly.",
    badges: [
      ["Grid3x3", "Fencing"],
      ["Shield", "Site Security"],
    ],
  },
  "chellan-highway-safety-services": {
    pitch:
      "Road marking, studs, anti-skid, the disciplines you only notice when they're wrong. Chellan makes sure you never notice.",
    badges: [
      ["Route", "Road Marking"],
      ["Layers", "Anti-skid Systems"],
    ],
  },
  "city-tm": {
    pitch:
      "Traffic management that punches above its weight, event work, high-speed schemes and local-authority contracts across the South East.",
    badges: [
      ["Construction", "Traffic Management"],
      ["TrafficCone", "Event & Highway TM"],
    ],
  },
  coeval: {
    pitch:
      "Vehicle-activated signs and warning tech that actually work in the field. Practical safety engineering, made in Scotland.",
    badges: [
      ["Radio", "ITS Technology"],
      ["Shield", "Warning Signs"],
    ],
  },
  "consilium-technical-services": {
    pitch:
      "The kind of technical brain trust major highways schemes lean on quietly. Consultancy with genuine sector chops.",
    badges: [
      ["ClipboardCheck", "Consultancy"],
      ["Cog", "Technical Services"],
    ],
  },
  "core-highways": {
    pitch:
      "One of the fastest-growing national TM and barrier groups. Acquisitive, ambitious, and increasingly the name behind headline schemes.",
    badges: [
      ["Construction", "Traffic Management"],
      ["Shield", "Barrier Systems"],
    ],
  },
  "crown-highways": {
    pitch:
      "The Midlands' quietly formidable highways electrical and lighting contractor. Lighting, comms, ITS installs, civils, done at scale, done properly.",
    badges: [
      ["Lightbulb", "Highways Lighting"],
      ["Zap", "Highways Electrical"],
    ],
  },
  "crown-plus": {
    pitch:
      "The support layer under a lot of headline projects, skilled operatives, plant, and delivery capacity you can actually count on.",
    badges: [
      ["Users", "Labour Supply"],
      ["HardHat", "Plant & Support"],
    ],
  },
  "deltabloc-uk": {
    pitch:
      "A serious global name in vehicle-restraint systems. Concrete and steel that stops what it's designed to stop, tested to the standards that matter.",
    badges: [
      ["Shield", "Vehicle Restraint"],
      ["Layers", "Barrier Systems"],
    ],
  },
  "highway-care": {
    pitch:
      "One of the sector's most innovation-hungry safety businesses. Automated cone laying, work-zone tech, national barrier programmes, Highway Care keeps moving the safety conversation forward.",
    badges: [
      ["Shield", "Road Safety"],
      ["Cog", "Work-zone Automation"],
    ],
  },
  "hill-and-smith-infrastructure": {
    pitch:
      "A cornerstone UK manufacturer of vehicle-restraint systems and bridge parapets. If it's holding a vehicle back on a UK strategic road, there's a good chance Hill & Smith made it.",
    badges: [
      ["Shield", "Vehicle Restraint"],
      ["Building2", "Bridge Parapets"],
    ],
  },
  hrs: {
    pitch:
      "Building the automated future of work-zone safety. Automated tapers and digital protection systems that reduce operative exposure at speed.",
    badges: [
      ["Shield", "Work-zone Safety"],
      ["Cog", "Automation Technology"],
    ],
  },
  htm: {
    pitch:
      "The old-school name that still delivers. Traffic management on high-speed and urban schemes, run by a team that knows the industry inside out.",
    badges: [
      ["Construction", "Traffic Management"],
      ["TrafficCone", "High-speed Works"],
    ],
  },
  hireway: {
    pitch:
      "Specialist fleet hire built specifically for the highways operating environment. When contractors need the right vehicle yesterday, Hireway sends it.",
    badges: [
      ["Truck", "Fleet Hire"],
      ["Wrench", "Specialist Vehicles"],
    ],
  },
  "institute-of-asphalt-technology": {
    pitch:
      "The professional home for UK asphalt and surfacing engineers. Membership, learning, credibility, everything the discipline needs to keep raising standards.",
    badges: [
      ["Award", "Professional Body"],
      ["GraduationCap", "Training & CPD"],
    ],
  },
  instarmac: {
    pitch:
      "The UltraCrete team behind more UK highways repairs than most drivers realise. Materials that fix problems fast, the kind that keep networks moving.",
    badges: [
      ["Layers", "Highway Materials"],
      ["Wrench", "Rapid Repair"],
    ],
  },
  "kiely-bros": {
    pitch:
      "Surface treatments, road marking, and highways contracting from a business that's been shaping UK roads for decades. Independent, family-run, seriously capable.",
    badges: [
      ["Layers", "Surface Treatments"],
      ["Route", "Road Marking"],
    ],
  },
  "kier-transportation-services": {
    pitch:
      "One of the biggest names in UK infrastructure delivery. From major schemes to term maintenance, Kier's fingerprints are on the network in every region.",
    badges: [
      ["HardHat", "Major Contractor"],
      ["Building2", "Infrastructure"],
    ],
  },
  "king-highway-products": {
    pitch:
      "The company that reinvented pothole patching as a craft. King's rigs and materials sit at the technical heart of asphalt repair across the UK and beyond.",
    badges: [
      ["Wrench", "Patching Systems"],
      ["Truck", "Highway Machinery"],
    ],
  },
  "mac-surfacing": {
    pitch:
      "A Black Country surfacing outfit turning out consistent quality across the West Midlands and beyond. No fanfare, just proper roads, delivered.",
    badges: [
      ["Layers", "Surfacing"],
      ["Route", "Asphalt Contracting"],
    ],
  },
  "m-group-telecom": {
    pitch:
      "One of the UK's biggest telecoms infrastructure delivery businesses. Design, build, maintain, the field engine that keeps the network on.",
    badges: [
      ["Radio", "Telecoms"],
      ["Wrench", "Infrastructure Services"],
    ],
  },
  meon: {
    pitch:
      "The specialist behind a huge slice of UK line-marking and anti-skid work. Materials, machinery, training, Meon has the discipline covered.",
    badges: [
      ["Route", "Line Marking"],
      ["PaintBucket", "Materials & Resins"],
    ],
  },
  "messagemaker-displays-stocksigns-ltd": {
    pitch:
      "Variable-message signs, LED displays, speed signs, safety signage, the visible communications kit that keeps traffic informed and moving.",
    badges: [
      ["Signpost", "VMS & Signage"],
      ["Lightbulb", "LED Displays"],
    ],
  },
  "metelec-services": {
    pitch:
      "Electrical and mechanical installs that keep infrastructure powered. Reliable engineering, delivered without drama.",
    badges: [
      ["Zap", "Electrical Contracting"],
      ["Cog", "Mechanical Services"],
    ],
  },
  "miles-macadam": {
    pitch:
      "Hardipave and a portfolio of specialist surfacing solutions used on some of the UK's toughest asphalt jobs. Innovation with proper technical rigour.",
    badges: [
      ["Layers", "Specialist Surfacing"],
      ["Route", "Hardipave"],
    ],
  },
  "milestone-infrastructure": {
    pitch:
      "Term maintenance and highways services at national scale, delivered by one of the biggest players in the local-authority partnership market.",
    badges: [
      ["HardHat", "Highways Maintenance"],
      ["Route", "Term Contracts"],
    ],
  },
  multevo: {
    pitch:
      "Multi-purpose kit, in-house patching services, and a genuine claim to being the country's most efficient road-maintenance approach. Multevo is a team that runs on results.",
    badges: [
      ["Truck", "Multi-purpose Kit"],
      ["Wrench", "Patching Services"],
    ],
  },
  "national-highways": {
    pitch:
      "The organisation running England's strategic road network. Everything that happens on the motorways and A-roads that matter starts here.",
    badges: [
      ["Landmark", "Public Body"],
      ["Route", "Strategic Road Network"],
    ],
  },
  "nissen-uk": {
    pitch:
      "Traffic-management lighting, warning lamps, barriers, signs, Nissen's kit shows up wherever UK sites need proper temporary safety.",
    badges: [
      ["Lightbulb", "TM Lighting"],
      ["Shield", "Safety Equipment"],
    ],
  },
  pogo: {
    pitch:
      "SWARCO's public EV charging network, visible, fast, and rolling out across the UK. A rare EV brand that actually shows up on the roadside where it matters.",
    badges: [
      ["Zap", "EV Charging"],
      ["Sun", "Public Network"],
    ],
  },
  "randc-williams": {
    pitch:
      "The Midlands civils firm the industry quietly relies on for bridge and structural repair work. A serious technical shop with a long list of headline structures behind it.",
    badges: [
      ["Building2", "Bridge & Structures"],
      ["HardHat", "Structural Civils"],
    ],
  },
  "ramudden-global-uk-chevron-tm": {
    pitch:
      "The UK arm of Ramudden Global, one of the biggest names in traffic management on the planet. Serious operational muscle behind every scheme.",
    badges: [
      ["Construction", "Traffic Management"],
      ["Shield", "Work-zone Safety"],
    ],
  },
  "re-flow": {
    pitch:
      "The field-management software that highways and infrastructure businesses actually use. Built with the sector, sold across the sector, and quietly changing how sites run.",
    badges: [
      ["Cpu", "Field Software"],
      ["ClipboardCheck", "Operations Platform"],
    ],
  },
  "roadway-tm": {
    pitch:
      "A traffic-management contractor with a genuine field culture, the kind of team clients call back because the last job got done properly.",
    badges: [
      ["Construction", "Traffic Management"],
      ["TrafficCone", "High-speed Works"],
    ],
  },
  shimpac: {
    pitch:
      "The go-to name for impact protection on works vehicles. Simple, robust kit that catches what it needs to catch.",
    badges: [
      ["Shield", "Impact Protection"],
      ["Truck", "Works Vehicles"],
    ],
  },
  "solar-gates": {
    pitch:
      "Solar-powered automatic barriers that solve one of the sector's ugliest safety problems, work-zone incursions. Practical innovation, doing its job in the middle of the night.",
    badges: [
      ["Sun", "Solar Powered"],
      ["Shield", "Incursion Protection"],
    ],
  },
  swarco: {
    pitch:
      "A global mobility group with real UK depth, road marking, traffic signals, intelligent transport systems and clean-mobility infrastructure all under one roof.",
    badges: [
      ["Route", "Road Marking"],
      ["Cpu", "ITS & Signals"],
    ],
  },
  "swarco-smart-charging": {
    pitch:
      "SWARCO's EV charging arm, hardware, software, network. The full-stack partner for local authorities and operators building charging at pace.",
    badges: [
      ["Zap", "EV Infrastructure"],
      ["Cpu", "Charging Network"],
    ],
  },
  "tailored-highway-support-ths": {
    pitch:
      "Training, consultancy, and TM support delivered by people who actually know the roadside job. Bespoke, practical, industry-facing.",
    badges: [
      ["GraduationCap", "Training"],
      ["Users", "Support Services"],
    ],
  },
  tarmac: {
    pitch:
      "One of the UK's cornerstone materials and road-services businesses. Asphalt, aggregates, concrete, contracts, Tarmac is under and around most of the network.",
    badges: [
      ["Layers", "Asphalt & Materials"],
      ["Route", "Road Services"],
    ],
  },
  "ths-training": {
    pitch:
      "Lantra-accredited highways and traffic-management training with a reputation for actually turning learners into competent operatives.",
    badges: [
      ["GraduationCap", "Training"],
      ["Award", "Lantra Accredited"],
    ],
  },
  "thomson-protective-coatings": {
    pitch:
      "Protective coatings on bridges, structures and steelwork, the discipline that quietly protects UK infrastructure from the weather that would otherwise eat it.",
    badges: [
      ["PaintBucket", "Protective Coatings"],
      ["Building2", "Bridges & Structures"],
    ],
  },
  tmca: {
    pitch:
      "The trade body representing UK traffic-management contractors. The industry's collective voice on standards, safety and policy.",
    badges: [
      ["Landmark", "Trade Association"],
      ["Award", "Standards & Policy"],
    ],
  },
  "traffic-group-signals": {
    pitch:
      "The biggest hirer of portable traffic signals in the UK, with a genuine claim on the technology innovation behind them.",
    badges: [
      ["Signpost", "Portable Signals"],
      ["Cog", "Signal Technology"],
    ],
  },
  "traffic-labour-supplies-tls": {
    pitch:
      "The recruitment and labour engine behind a huge slice of UK traffic-management and civils operations. Serious people-pipeline capacity.",
    badges: [
      ["Users", "Labour Supply"],
      ["HardHat", "Recruitment"],
    ],
  },
  "transport-for-london": {
    pitch:
      "The public body responsible for London's transport network, roads, buses, rail, cycling, major highways programmes, and one of the most-watched procurement pipelines in the country.",
    badges: [
      ["Landmark", "Public Body"],
      ["Route", "London Network"],
    ],
  },
  "triangle-software": {
    pitch:
      "Purpose-built software for traffic-management and field-service businesses. Made by people who've actually run those operations.",
    badges: [
      ["Cpu", "Software"],
      ["ClipboardCheck", "Operations Tools"],
    ],
  },
  "up-to-speed-training": {
    pitch:
      "Traffic management, plant, and workplace safety training, delivered with the industry-facing polish that turns qualifications into actual competence.",
    badges: [
      ["GraduationCap", "Training"],
      ["Award", "Qualifications"],
    ],
  },
  "uk-sandbags": {
    pitch:
      "Filled sandbags, flood-protection products, and emergency-response materials at the scale UK winters demand. A quietly essential part of the infrastructure resilience picture.",
    badges: [
      ["Package", "Flood Protection"],
      ["Layers", "Emergency Response"],
    ],
  },
  velocity: {
    pitch:
      "Spray-injection patching that lets councils fix potholes faster than the weather can create them. Genuine engineering behind one of the sector's most visible problems.",
    badges: [
      ["Wrench", "Pothole Repair"],
      ["Truck", "Mobile Repair Systems"],
    ],
  },
  volkerhighways: {
    pitch:
      "Term maintenance, street lighting, public realm, surfacing, the delivery arm of VolkerWessels UK, working for local authorities across the country.",
    badges: [
      ["HardHat", "Term Maintenance"],
      ["Lightbulb", "Street Lighting"],
    ],
  },
  wdm: {
    pitch:
      "The name behind SCRIM and much of the UK's road-condition survey machinery. When someone measures the road surface, WDM's technology is usually doing the measuring.",
    badges: [
      ["Search", "Road Survey"],
      ["Cog", "Survey Technology"],
    ],
  },
  wj: {
    pitch:
      "One of the UK's most technically ambitious road-marking groups. Retro-reflection science, sustainability commitments, and a project sheet most competitors would envy.",
    badges: [
      ["Route", "Road Marking"],
      ["Layers", "Retro-reflection"],
    ],
  },
};
